"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateNavigation = exports.initialState = exports.getCurrentNavId = exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
const initialState = exports.initialState = {
  currentNavURL: undefined,
  selectedId: undefined
};
const updateNavigation = exports.updateNavigation = (0, _toolkit.createAction)("updateNavigation");
const getCurrentNavId = function (state) {
  return state.selectedId;
};
exports.getCurrentNavId = getCurrentNavId;
var _default = exports.default = (0, _toolkit.createReducer)(initialState, function (builder) {
  builder.addCase(updateNavigation, function (state, action) {
    state.currentNavURL = action.payload.url;
    state.selectedId = action.payload.id;
  });
});